<button (click)="handleClick()" class="backgroundPicProfile" [class.fit-contain]="fit === 'contain'" type="button">
  <!-- Loading do Ionic centralizado -->
  <ion-spinner *ngIf="image && !imageLoaded" name="crescent" class="loading-spinner"></ion-spinner>
  
  <!-- Imagem simples sem lazy loading -->
  <img *ngIf="image"
    [ngStyle]="customStyle"
    [src]="currentSrc"
    [alt]="'Profile'"
    (load)="onImageLoad($event)"
    (error)="onImageError($event)"
    class="simple-image"
    [style.display]="imageLoaded ? 'block' : 'none'"
    [style.border-radius]="borderRadius"
    [style.width]="width"
    [style.object-fit]="fit"
    />
    
</button>
